import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { Radio } from 'informed'
import styles from './Radio.module.scss'

const StyledRadio = ({ smartSubmit, inline, label, noForm, styleInverted, ...rest }) => (
	<div
		className={
			classNames(styles.root, { inline: inline, [`${'field-disabled'}`]: rest.disabled, [styles.inverted]: styleInverted })
		}
	>
		<label className={styles.label}>
			{noForm ?
				<input type='radio' { ...rest }/> :
				<Radio
					onChange={e => {
						if(rest.onChange) {
							rest.onChange(e)
						}
						if(smartSubmit) {
							smartSubmit.submit(e)
						}
					}}
					{ ...rest }
				/>
			}
			<span className={styles.box}/>
			<span className={styles.labelText}>{label}</span>
		</label>
	</div>
)

StyledRadio.propTypes = {
	label: PropTypes.string,
	field: PropTypes.string,
	inline: PropTypes.bool,
	noForm: PropTypes.bool,
	disabled: PropTypes.bool,
	styleInverted: PropTypes.bool
}

export default StyledRadio
